export class StatTypes {
    rowNum:number;
    id: number;
    codigo: string;
    nombre: string; 
    }